import { render, staticRenderFns } from "./ShowChangesModal.vue?vue&type=template&id=decfd630&"
import script from "./ShowChangesModal.vue?vue&type=script&lang=js&"
export * from "./ShowChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports